import { cn } from "@/lib/utils";
import type { TaskStepState } from "./task-progress";

const stateClass: Record<TaskStepState, string> = {
  current: "border-primary bg-primary text-primary-foreground",
  done: "border-success/40 bg-success/10 text-success",
  rejected: "border-danger/40 bg-danger/10 text-danger",
  todo: "border-border/60 bg-surface text-faint-foreground",
};

/**
 * One numbered dot per item of the batch: current, done, rejected or to do.
 * Build `steps` with taskSteps() from task-progress.ts. `labels` gives the
 * accessible name of each state.
 */
export function TaskStepDots({
  steps,
  labels,
  className,
}: {
  steps: TaskStepState[];
  labels: Record<TaskStepState, string>;
  className?: string;
}) {
  if (steps.length === 0) return null;
  return (
    <ol className={cn("flex flex-wrap items-center gap-1.5", className)}>
      {steps.map((state, index) => (
        <li key={index}>
          <span
            className={cn("grid size-7 place-items-center rounded-full border text-[11px] font-semibold tabular-nums", stateClass[state])}
            aria-current={state === "current" ? "step" : undefined}
            title={labels[state]}
          >
            {index + 1}
            <span className="sr-only">{` ${labels[state]}`}</span>
          </span>
        </li>
      ))}
    </ol>
  );
}
